import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { HistoricoMigrado } from "src/components/projetos/historico/HistoricoMigrado";
import { appStore } from "src/framework/store/AppStore";
import { getComponentes } from "src/store/global.store";

const PAGE_TITLE = "Histórico Projeto Migrado";

const ProjetoHistoricoMigradoPage = () => {
    const params: any = useParams();
    useEffect(() => {
        getComponentes();
        appStore.setPageTitle(PAGE_TITLE);
        return () => {
            appStore.setPageTitle("");
        }
    }, [])


    return (
        <div className="container">
            <div className="row">
                <div className="X12">
                    <HistoricoMigrado
                        codigoProjeto={params?.codigo_projeto} 
                    />
                </div>
            </div>
        </div>
    );
};

export { ProjetoHistoricoMigradoPage };
